import useKeyPress, { MODIFIER_KEYS } from "./useKeyPress";

export default useKeyPress;
export { MODIFIER_KEYS };
